export default "__VITE_ASSET__3dfc5010__"